import React from 'react'
import HeaderOne from "../components/header/HeaderOne";
import Breadcrumb from "./Breadcrumb";
import ServiceEleven from "../components/service/ServiceEleven";




import FooterOne from "../components/footer/FooterOne";

function OurService() {
    const breadcrumbs = [
        { label: 'Accueil', link: '/' },
        { label: 'Services' }
    ];
    return (
        <div className=''>

            <HeaderOne />
            <Breadcrumb title="Services" breadcrumbs={breadcrumbs} />
            <ServiceEleven />


            <FooterOne />

        </div>
    )
}

export default OurService